import { Component, OnInit, Inject } from '@angular/core';
import { ActivatedRoute, ParamMap, Route, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { SimpleSearch } from 'src/app/core/models/simple-search.model';
import { DisplayErrorService } from 'src/app/shared/display-error/display-error.service';
import { Client, ClientAllowedScope, ClientClaim, ClientSecrect, CreateClientSecretRequest } from '../models/client.model';
import { ClientService } from '../services/client.service';
import { UserService } from '../services/user.service';
import { AddClientSecretModalComponent } from './add-client-secret-modal/add-client-secret.component';

@Component({
    selector: 'client-details',
    templateUrl: './client-details.component.html',
    standalone: false
})
export class ClientDetailsComponent implements OnInit {

    public client: Client;
    public clientSecrets: ClientSecrect[];
    public isLoadingClientSecrets: boolean = true;
    public isLoadingClient: boolean = true;
    public clientId: string = '';

    constructor(
        private router: Router,
        private route: ActivatedRoute,
        private modalService: NgbModal,
        private clientService: ClientService,
        private errorNotification: DisplayErrorService) {
        this.clientSecrets = [];
        this.client = new Client();
    }

    ngOnInit(): void {

        this.route.paramMap
            .subscribe(params => {
                this.clientId = params.get('clientId');
                this.loadClient();
                this.loadClientSecrets();
            });

    }

    loadClient() {
        this.isLoadingClient = true;
        this.clientService.getClient(this.clientId)
            .then(response => {
                console.log('### Client ###', response.client);
                this.client = response.client;
            }).catch(error => {

            }).finally(() => {
                this.isLoadingClient = false;
            });
    }

    loadClientSecrets() {
        this.isLoadingClientSecrets = true;

        this.clientService.listClientSecrets(this.clientId)
            .then(response => {
                this.clientSecrets = response.secrets;
            }).catch(error => {
            }).finally(() => {
                this.isLoadingClientSecrets = false;
            });
    }

    toggleEnable(client: Client) {

        if (client.isBusy)
            return;

        if (!confirm(`Do you want to ${client.enabled ? 'disable' : 'enable'} ${client.clientId}?`))
            return;

        client.isBusy = true;

        if (client.enabled) {
            this.clientService.disableClient(client.clientId).then(x => {
                client.enabled = false;
                client.isBusy = false;
            });
        } else {
            this.clientService.enableClient(client.clientId).then(x => {
                client.enabled = true;
                client.isBusy = false;
            });
        }
    }

    addClientAllowedScope() {
        let scope = prompt("Scope");
        if (!scope)
            return;

        this.clientService.addClientAllowedScope(this.clientId, scope).then(() => {
            this.loadClient();
        }, (response) => {
            this.errorNotification.display(response.error);
        });
    }

    addSecret() {

        const modalRef = this.modalService.open(AddClientSecretModalComponent,
            { backdrop: 'static', centered: true });

        modalRef.result.then((clientSecret: CreateClientSecretRequest) => {

            clientSecret.clientId = this.clientId;
            console.log(clientSecret);

            this.clientService.addClientSecret(clientSecret).then(() => {
                this.loadClientSecrets();
                // this.router.navigate(['clients', clientSecret.clientId, 'details'], { queryParams: { cbs: Math.random().toString(36).substring(7) } });
            }, (response) => {
                this.errorNotification.display(response.error);
            });

        }, () => {
            // Do nothing on modal cancel.
        });
    }

    deleteSecret(clientId: string, secretId: number) {
        this.clientService.delteClientSecret(clientId, secretId).then(() => {
            this.loadClientSecrets();
        }, (response) => {
            this.errorNotification.display(response.error);
        });
    }

    deleteAllowedScope(scopeId: number) {
        this.clientService.deleteClientAllowedScope(this.clientId, scopeId).then(() => {
            this.loadClient();
        }, (response) => {
            this.errorNotification.display(response.error);
        });
    }

    addClientClaim() {
        let key = prompt("Claim Key");
        if (!key)
            return;

        let value = prompt("Claim Value");
        if(!value)
            return;

        this.clientService.addClientClaim(this.clientId, key, value).then(() => {
            this.loadClient();
        }, (response) => {
            this.errorNotification.display(response.error);
        });
    }

    deleteClaim(claimId: number) {
        this.clientService.deleteClientClaim(this.clientId, claimId).then(() => {
            this.loadClient();
        }, (response) => {
            this.errorNotification.display(response.error);
        });
    }
}



